import Student from '../../views/Student/Student.view';

export default Student;